module.exports = __webpack_public_path__ + "290a54d31fbbecc3c4f28c44c0821afa.pdf";